/** @jsxImportSource @wsxjs/wsx-core */
import { LightComponent, autoRegister, state } from '@wsxjs/wsx-core';
import './my-quiz-question.css';

@autoRegister({ tagName: 'my-quiz-question' })
export class MyQuizQuestion extends LightComponent {
  @state private selectedOption: number | null = -1;

  static get observedAttributes() {
    return ['question', 'options'];
  }

  protected onAttributeChanged(name: string, _oldValue: string, newValue: string) {
    if (name === 'question' || name === 'options') {
      this.selectedOption = null;
    }
  }

  private getQuestion(): string {
    return this.getAttribute('question') || 'No question provided';
  }

  private getOptions(): string[] {
    const optionsAttr = this.getAttribute('options') || '[]';
    try {
      return JSON.parse(optionsAttr);
    } catch (e) {
      console.error('Failed to parse options:', e);
      return [];
    }
  }

  private handleOptionClick(index: number, option: string) {
    this.selectedOption = index;
    this.dispatchEvent(
      new CustomEvent('option-selected', {
        detail: { index, option },
        bubbles: true,
      })
    );
  }

  render() {
    const question = this.getQuestion();
    const options = this.getOptions();

    return (
      <div className="my-quiz-question">
        <h3 className="my-quiz-question-title">{question}</h3>
        <div className="my-quiz-question-options">
          {options.map((opt: string, i: number) => (
            <button
              key={i}
              className={`my-quiz-question-option ${this.selectedOption === i ? 'selected' : ''}`}
              onClick={() => this.handleOptionClick(i, opt)}
            >
              {opt}
            </button>
          ))}
        </div>
      </div>
    );
  }
}
